<template>
    <span class="section-title__pointer" @click="$emit('click')">
        <fa-icon :icon="open ? 'minus' : 'plus'" />
        {{ title }}
        <span slot></span>
    </span>
</template>
<script>
export default {
    props: {
        open: {
            type: Boolean,
            default: false,
            required: false
        },
        title: {
            type: String,
            default: 'Titulo',
            required: true
        }
    }
}
</script>
<style scoped>
    .section-title__pointer {
        cursor:pointer;
    }
</style>


// WEBPACK FOOTER //
// src/views/followair/atualizacao-manual/components/sectionTitle/sectionTitle.vue